import CHARM_PERIPHERY_ABI from 'abis/CharmPeriphery.json'
import CHARM_VAULT_ABI from 'abis/CharmVault.json'
import { CHARM_PERIPHERY_ADDRESSES } from 'constants/addresses'
import { useConnection } from 'hooks/useConnection'
import { Abi, Address } from 'viem'

import { useVaultUnderlyingData, VaultUnderlyingData } from './useVaultUnderlyingData'

export type CharmUnderlyingData = VaultUnderlyingData

export function useGetCharmUnderlyingAmounts(vaultAddresses: Address[]) {
  const { chainId } = useConnection()
  const peripheryAddress = CHARM_PERIPHERY_ADDRESSES[chainId]

  const { data: charmUnderlyingAmounts } = useVaultUnderlyingData(vaultAddresses, {
    totalSupply: {
      abi: CHARM_VAULT_ABI as Abi,
    },
    balances: {
      abi: CHARM_PERIPHERY_ABI as Abi,
      functionName: 'getVaultAmounts',
      address: peripheryAddress,
    },
    enabled: !!peripheryAddress,
    logFailures: true,
  })

  return charmUnderlyingAmounts
}
